"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var framepay_error_1 = __importDefault(require("../../framepay-error"));

var base_element_1 = __importDefault(require("./base-element"));

var CardElement = function (_super) {
  __extends(CardElement, _super);

  function CardElement() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CardElement.prototype.setupElement = function () {
    var _this = this;

    var _a = this.props,
        onReady = _a.onReady,
        onChange = _a.onChange,
        onFocus = _a.onFocus,
        onBlur = _a.onBlur,
        elementType = _a.elementType;

    var makeElement = function makeElement() {
      // elementNode already checked in BaseElement.handleSetupElement
      // just ts checks fix
      if (!_this.elementNode) {
        throw framepay_error_1.default({
          code: framepay_error_1.default.codes.elementMountError,
          details: "CardElement invalid elementNode, elementType: " + (elementType || 'default')
        });
      }

      try {
        return _this.props.Rebilly.card.mount(_this.elementNode, elementType);
      } catch (e) {
        throw framepay_error_1.default({
          code: framepay_error_1.default.codes.elementMountError,
          details: "CardElement error in remote api call, elementType: " + (elementType || 'default'),
          trace: e
        });
      }
    };

    var element = makeElement();

    try {
      element.on('ready', function () {
        _this.setState({
          ready: true
        }, function () {
          if (onReady) {
            onReady();
          }
        });
      });
      element.on('change', function (data) {
        if (onChange) {
          onChange(data);
        }
      });
      element.on('focus', function () {
        if (onFocus) {
          onFocus();
        }
      });
      element.on('blur', function () {
        if (onBlur) {
          onBlur();
        }
      });
      this.setState({
        element: element
      });
    } catch (e) {
      throw framepay_error_1.default({
        code: framepay_error_1.default.codes.elementMountError,
        details: "CardElement events binding error, elementType: " + (elementType || 'default'),
        trace: e
      });
    }
  };

  return CardElement;
}(base_element_1.default);

exports.default = CardElement;